export default "//cloud.imgsmail.ru/cloud.mail.ru/164372/img/build/aside-promo-modal/kaspersky-cover.jpg";